module.exports = __webpack_public_path__ + "img/galeria-vertebrados2.2e9f704b.jpg";